import { render } from "./SeparatorBlock.vue?vue&type=template&id=0d9f25fa&scoped=true"
import script from "./SeparatorBlock.vue?vue&type=script&lang=js"
export * from "./SeparatorBlock.vue?vue&type=script&lang=js"

import "./SeparatorBlock.vue?vue&type=style&index=0&id=0d9f25fa&lang=scss&scoped=true"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d9f25fa"]])

export default __exports__